import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ADHomePage from "./pages/ADHomePage";
import { BooksPage, AboutPage, ContactPage } from "./pages/ADSubPages";
import RealtyPage from "./pages/RealtyPage";
import TapPage from "./pages/TapPage";
import PressPage from "./pages/PressPage";
import { AmberAlertPage, TeamHustlePage, NightOwlPage, FeedingCommunityPage, CarsForFamiliesPage, PTCPage, SpeakingPage } from "./pages/InitiativePages";
import AssetsPage from "./pages/AssetsPage";
import GhostAssistant from "./components/GhostAssistant";

function App() {
  useEffect(() => {
    const badge = document.getElementById("emergent-badge");
    if (badge) badge.remove();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ADHomePage />} />
          <Route path="/books" element={<BooksPage />} />
          <Route path="/realty" element={<RealtyPage />} />
          <Route path="/tap" element={<TapPage />} />
          <Route path="/press" element={<PressPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/initiatives/amber-alert" element={<AmberAlertPage />} />
          <Route path="/initiatives/team-hustle" element={<TeamHustlePage />} />
          <Route path="/initiatives/night-owl" element={<NightOwlPage />} />
          <Route path="/initiatives/feeding-community" element={<FeedingCommunityPage />} />
          <Route path="/initiatives/cars-for-families" element={<CarsForFamiliesPage />} />
          <Route path="/initiatives/ptc" element={<PTCPage />} />
          <Route path="/initiatives/speaking" element={<SpeakingPage />} />
          <Route path="/assets" element={<AssetsPage />} />
        </Routes>
        <GhostAssistant />
      </BrowserRouter>
    </div>
  );
}

export default App;
